import React from "react";

let SubmitButton = React.createClass({
    propTypes: {
        submitting: React.PropTypes.bool,
        text: React.PropTypes.string,
        submittingText: React.PropTypes.string,
        btnClassName: React.PropTypes.string,
        btnClassOverwrite: React.PropTypes.bool
    },
    getInitialState() {
        return {};
    },
    render() {
        return (
            <div className={this.props.className}>
                <button className={[(this.props.btnClassOverwrite ? "" : "eo-btn-submit"), this.props.btnClassName, (this.props.submitting ? "submitting" : null)].join(" ")} type="submit">
                    <span className="eo-btn-submit-text">{this.props.submitting ? (this.props.submittingText !== "$icon" ? (this.props.submittingText || "Submitting") : null) : (this.props.text !== "$icon" ? (this.props.text || "Submit") : null)}</span>
                </button>
            </div>
        );
    }
});

export default SubmitButton;



/** WEBPACK FOOTER **
 ** ./app/utils/components/SubmitButton.js
 **/